import { render, staticRenderFns } from "./Profissional.vue?vue&type=template&id=69d44007&scoped=true"
import script from "./Profissional.vue?vue&type=script&lang=js"
export * from "./Profissional.vue?vue&type=script&lang=js"
import style0 from "./Profissional.vue?vue&type=style&index=0&id=69d44007&prod&lang=scss&scoped=true"
import style1 from "./Profissional.vue?vue&type=style&index=1&id=69d44007&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d44007",
  null
  
)

export default component.exports